<template>
  <figure :class="['phone', { desktop: device === 'desktop' }]" :aria-label="label">
    <div class="phone-body">
      <div v-if="device !== 'desktop'" class="phone-top" aria-hidden="true"><span class="phone-speaker"></span></div>
      <div v-else class="browser-top" aria-hidden="true"><i></i><i></i><i></i><span class="browser-url">{{ url }}</span></div>
      <div class="phone-screen"><slot /></div>
    </div>
    <figcaption v-if="caption" class="phone-caption">{{ caption }}</figcaption>
  </figure>
</template>

<script>
export default {
  name: 'PhoneFrame',
  props: {
    device: { type: String, default: 'phone' },
    url: { type: String, default: '' },
    caption: { type: String, default: '' },
    label: { type: String, default: 'Preview' }
  }
};
</script>

<style scoped>
.phone{margin:0;width:100%;max-width:340px}
.phone.desktop{max-width:none}
.phone-body{position:relative;overflow:hidden;border-radius:38px;border:9px solid #1F2328;background:#1F2328;
  box-shadow:0 18px 48px rgba(60,42,24,.18),0 2px 6px rgba(60,42,24,.10)}
.desktop .phone-body{border-radius:14px;border-width:1px;border-color:#D4C9B8;background:#fff}
.phone-top{display:flex;justify-content:center;align-items:center;height:22px;background:#fff}
.phone-speaker{width:64px;height:6px;border-radius:6px;background:#E6DED2}
.browser-top{display:flex;align-items:center;gap:6px;height:36px;padding:0 12px;background:#F3EEE6;border-bottom:1px solid #E6DED2}
.browser-top i{width:10px;height:10px;border-radius:50%;background:#D4C9B8}
.browser-url{margin-left:12px;flex:1 1 auto;min-width:0;height:22px;padding:0 10px;border-radius:7px;background:#fff;color:#6B635B;
  font:500 11.5px/22px var(--font-body);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
.phone-screen{max-height:max(520px,calc(100vh - 205px));overflow-y:auto;background:#fff;border-radius:0 0 29px 29px;scrollbar-width:none}
.phone-screen::-webkit-scrollbar{display:none}
.desktop .phone-screen{max-height:680px;border-radius:0 0 13px 13px;background:#FAF7F2}
.phone-caption{margin-top:12px;text-align:center;font-size:13px;color:#6B635B}
/* The last line never sits on the rounded corner; on phones the frame grows with its content instead of scrolling. */
.phone-screen{padding-bottom:16px}
@media(max-width:600px){.phone-screen{max-height:none;overflow:visible}}
</style>
